'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./node_modules/shortid/index.js
// module id = 1912
// module chunks = 0